import { render, staticRenderFns } from "./SahabatZX.vue?vue&type=template&id=02ab8306"
import script from "./SahabatZX.vue?vue&type=script&lang=js"
export * from "./SahabatZX.vue?vue&type=script&lang=js"
import style0 from "./SahabatZX.vue?vue&type=style&index=0&id=02ab8306&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports